import React, { useState, useEffect } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom"; // Hook do React Router
import styles from "./CarrinhoIcon.module.css";

function CarrinhoIcon() {
  const [itemCount, setItemCount] = useState(0); // Estado para guardar a quantidade de itens
  const navigate = useNavigate(); // Hook para navegar entre páginas

useEffect(() => {
      const atualizarContador = () => {
        const carrinho = JSON.parse(localStorage.getItem("carrinho")) || [];
        const total = carrinho.reduce((t, item) => t + (item.quantidade || 1), 0);
        setItemCount(total);
      };

      atualizarContador(); // carrega inicialmente

      // Escuta tanto mudanças no localStorage (outra aba) quanto nosso evento customizado
      window.addEventListener("storage", atualizarContador);
      window.addEventListener("carrinhoAtualizado", atualizarContador);

      return () => {
        window.removeEventListener("storage", atualizarContador);
        window.removeEventListener("carrinhoAtualizado", atualizarContador);
      };
}, []);


  return (
    <div
      className={styles.cartContainer}
      onClick={() => navigate("/carrinhodeitens")} // 👉 Navega para a página /carrinho
    >
      {/* Ícone do carrinho */}
      <FiShoppingCart size={30} className={styles.carrinhoIcon} />

      {/* Badge vermelha com número de itens */}
      {itemCount > 0 && <span className={styles.badge}>{itemCount}</span>}
    </div>
  );
}

export default CarrinhoIcon;
